export const CREATE_APPOINTMENT = 'CREATE_APPOINTMENT';
export const CREATE_APPOINTMENT_SUCCESS = 'CREATE_APPOINTMENT_SUCCESS';
export const CREATE_APPOINTMENT_ERROR = 'CREATE_APPOINTMENT_ERROR';

export const REQUEST_PAYMENT = 'REQUEST_PAYMENT';
export const REQUEST_PAYMENT_SUCCESS = 'REQUEST_PAYMENT_SUCCESS';
export const REQUEST_PAYMENT_ERROR = 'REQUEST_PAYMENT_ERROR';

export const PAYMENT_CONFIRMED = 'PAYMENT_CONFIRMED';
export const PAYMENT_CONFIRMED_SUCCESS = 'PAYMENT_CONFIRMED_SUCCESS';
export const PAYMENT_CONFIRMED_ERROR = 'PAYMENT_CONFIRMED_ERROR';